module.exports = __webpack_public_path__ + "img/Bärlin.5fb3da49.jpg";